import * as React from "react";
import { Route, Redirect, Switch, withRouter, RouteComponentProps } from "react-router-dom";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import pathRoot from "../routes-path";
import pathEvidence from "../evidence/routes-path";
import Evidence from "../evidence/Evidence";
import pathInformace from "../informace/routes-path";
import Informace from "../informace/Informace";
import { withLogedUser, LogedUserProps, userHasPermissions } from "common/loged-user";


interface AppState {
    //   menuOpen: boolean;
}

type AppProps = RouteComponentProps<any> & LogedUserProps & WithStyles<typeof styles>;


class App extends React.Component<AppProps, AppState> {

    constructor(props: AppProps) {
        super(props);

    }

    render() {
        const { classes, logedUser } = this.props;

        return <div className={classes.root}>
            <main>
                <Switch>
                    <Route path={pathEvidence} render={() => <Evidence />} />
                    <Route path={pathInformace} render={() => <Informace />} />

                    <Redirect to={pathRoot} />
                </Switch>
            </main>
        </div>
    }
}

export const styles = (theme: Theme) => createStyles({
    root: {
        marginTop: 15,
    },
});


export default withStyles(styles)(withLogedUser(withRouter(App)));
